import React from 'react';
import { Link } from 'gatsby';
import convert from 'htmr';
import { parseHtmlLocation } from '../../Utilities/Utility';

const Content = ({ html }) => {
  const transform = {
    a: (node) => {
      const { href } = node;
      // create regular links if 'http:' or 'https' is found
      if (
        (href && href.substr(0, 5) === 'http:') ||
        (href && href.substr(0, 5) === 'https')
      ) {
        return <a href={href} target={node.target}>{node.children}</a>;
      }

      // create regular anchor tag with 'mail' in it.
      if (href && href.substr(0, 4) == 'mail') {
        return <a href={href}>{node.children}</a>;
      }

      // find all pound signs and re-create them with the current page link.
      if (href && href.includes('#') > 0) {
        return <a href={href}>{node.children}</a>;
      }

      if (href !== undefined) {
        return <Link to={`/${href}`}>{node.children}</Link>;
      } else {
        // Find link tags create them with name
        if (node.name) {
          // Leave href blank
          return (
            <a href='' name={node.name}>
              {node.children}
            </a>
          );
        }
        return <span>{node.children}</span>;
      }
    },
  };

  return <div>{convert(html, { transform })}</div>;
};

export default Content;
